import clsx from 'clsx';
import { Stack, StackProps } from 'src/core/ui';

import * as styles from './StatLabel.css';

export const StatLabel = ({
  title,
  stat,
  direction = 'column',
}: {
  title: string | React.ReactNode;
  stat: string | React.ReactNode;
} & Pick<StackProps, 'direction'>) => {
  if (stat == null || title == null) {
    return null;
  }

  return (
    <Stack
      direction={direction}
      alignItems={direction === 'column' ? 'start' : 'center'}
      justifyContent="center"
      gap={direction === 'column' ? undefined : 's'}
      className={styles.statLabel}
    >
      {direction === 'column' ? (
        <>
          <span
            title={typeof stat === 'string' ? stat : undefined}
            className={styles.statStyle}
          >
            {stat}
          </span>
          <span className={styles.titleStyle}>{title}</span>
        </>
      ) : (
        <>
          <span className={clsx(styles.titleStyle, styles.titleAfter)}>
            {title}
          </span>
          <span className={styles.statStyle}>{stat}</span>
        </>
      )}
    </Stack>
  );
};
